import { useCallback } from "react";
import { useSelector } from "react-redux";
import translations from "./translations";

const DEFAULT_LANGUAGE = "ar";

const format = (template, params) => {
  if (!params) {
    return template;
  }

  return Object.keys(params).reduce((result, key) => {
    const value = params[key];
    // Support {{key}}, {key} placeholders; escape braces for literal match
    const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const pattern = new RegExp(`\\{\\{\\s*${escapedKey}\\s*\\}\\}|\\{\\s*${escapedKey}\\s*\\}`, "g");
    return result.replace(pattern, String(value ?? ""));
  }, template);
};

export const useTranslation = () => {
  const language = useSelector((state) => state?.language?.language ?? DEFAULT_LANGUAGE);

  const t = useCallback(
    (key, params) => {
      const template =
        translations[language]?.[key] ??
        translations[DEFAULT_LANGUAGE]?.[key] ??
        translations.en?.[key] ??
        key;

      if (typeof template !== "string") {
        return template;
      }

      return format(template, params);
    },
    [language]
  );

  return { t, language };
};

export default useTranslation;
